<div class="config-page">

  <div class="page-head">

    <div>

      <div class="eyebrow">
        MODULE CONFIG
      </div>

      <h2>
        Roles
      </h2>

      <p>
        Create and manage application roles.
      </p>

    </div>


    <div class="head-actions">

      <button
        class="btn-light-custom"
        type="button"
        (click)="loadRoles()"
      >
        <i class="bi bi-arrow-clockwise"></i>
        Refresh
      </button>


      <button
        class="btn-primary-custom"
        type="button"
        (click)="openCreate()"
      >
        <i class="bi bi-plus-lg"></i>
        Add Role
      </button>

    </div>

  </div>


  <div
    class="form-card"
    *ngIf="showForm"
  >

    <div class="card-title-row">

      <div>

        <h5>
          {{
            form.roleId > 0
              ? "Edit Role"
              : "Create Role"
          }}
        </h5>

        <p>
          Configure role details and module mapping.
        </p>

      </div>

    </div>


    <div class="row g-3">

      <div class="col-md-4">

        <label>
          Role Name *
        </label>

        <input
          class="form-control"
          [(ngModel)]="form.roleName"
          (blur)="onRoleNameBlur()"
          maxlength="100"
        />

      </div>


      <div class="col-md-4">

        <label>
          Role Code *
        </label>

        <input
          class="form-control"
          [(ngModel)]="form.roleCode"
          maxlength="50"
        />

      </div>


      <div class="col-md-4">

        <label>
          Module Name *
        </label>

        <select
          class="form-select"
          [(ngModel)]="form.moduleName"
          (ngModelChange)="onModuleNameChange()"
        >

          <option value="">
            Select Module
          </option>

          <option
            *ngFor="
              let module of moduleOptions
            "
            [value]="module"
          >
            {{ module }}
          </option>

        </select>

      </div>


      <div class="col-md-4">

        <label>
          {{ moduleEntityLabel }}
          <span
            *ngIf="!requiresModuleEntity"
          >
            (Optional)
          </span>
          <span
            *ngIf="requiresModuleEntity"
          >
            *
          </span>
        </label>

        <select
          class="form-select"
          [(ngModel)]="form.moduleId"
          [disabled]="
            !requiresModuleEntity ||
            loadingModuleEntities
          "
        >

          <option [ngValue]="0">
            {{
              loadingModuleEntities
                ? "Loading..."
                : moduleEntityPlaceholder
            }}
          </option>

          <option
            *ngFor="
              let entity of moduleEntities
            "
            [ngValue]="entity.id"
          >
            {{ entity.name }}
          </option>

        </select>

        <small
          *ngIf="
            requiresModuleEntity &&
            !loadingModuleEntities &&
            moduleEntities.length === 0
          "
          class="text-muted"
        >
          No onboarded records found.
        </small>

      </div>


      <div
        class="col-md-4"
        *ngIf="form.roleId > 0"
      >

        <label>
          Status
        </label>

        <select
          class="form-select"
          [(ngModel)]="form.isActive"
        >

          <option [ngValue]="1">
            Active
          </option>

          <option [ngValue]="0">
            Inactive
          </option>

        </select>

      </div>


      <div class="col-12">

        <label>
          Description
        </label>

        <textarea
          class="form-control"
          rows="3"
          [(ngModel)]="form.roleDesc"
          maxlength="500"
        ></textarea>

      </div>

    </div>


    <div class="form-footer">

      <button
        type="button"
        class="btn-light-custom"
        (click)="cancelForm()"
      >
        Cancel
      </button>


      <button
        type="button"
        class="btn-primary-custom"
        [disabled]="
          saving ||
          loadingModuleEntities
        "
        (click)="saveRole()"
      >

        <span
          class="spinner-border spinner-border-sm"
          *ngIf="saving"
        ></span>

        {{
          saving
            ? "Saving..."
            : form.roleId > 0
              ? "Update Role"
              : "Create Role"
        }}

      </button>

    </div>

  </div>


  <div class="data-card">

    <div class="table-toolbar">

      <div>

        <h5>
          Role List
        </h5>

        <small>
          {{ filteredRoles.length }}
          role(s)
        </small>

      </div>


      <div class="search-box">

        <i class="bi bi-search"></i>

        <input
          type="text"
          [(ngModel)]="searchText"
          placeholder="Search roles..."
          (ngModelChange)="pageNo = 1"
        />

      </div>

    </div>


    <div
      class="loading-box"
      *ngIf="loading"
    >

      <span
        class="spinner-border spinner-border-sm"
      ></span>

      Loading roles...

    </div>


    <div
      class="table-responsive"
      *ngIf="!loading"
    >

      <table class="config-table">

        <thead>

          <tr>
            <th>Role</th>
            <th>Code</th>
            <th>Group</th>
            <th>Module</th>
            <th>Status</th>
            <th class="text-end">
              Actions
            </th>
          </tr>

        </thead>


        <tbody>

          <tr
            *ngFor="
              let role of paginatedRoles
            "
          >

            <td>

              <strong>
                {{ role.roleName }}
              </strong>

            </td>


            <td>
              {{ role.roleCode }}
            </td>


            <td>
              {{ role.groupName || "-" }}
            </td>


            <td>
              {{ role.moduleName || "-" }}
            </td>


            <td>

              <span
                class="status active"
                *ngIf="role.isActive === 1"
              >
                Active
              </span>

              <span
                class="status inactive"
                *ngIf="role.isActive !== 1"
              >
                Inactive
              </span>

            </td>


            <td class="text-end">

              <button
                class="icon-btn edit"
                type="button"
                (click)="editRole(role)"
              >
                <i class="bi bi-pencil"></i>
              </button>

              <button
                class="icon-btn delete"
                type="button"
                (click)="deleteRole(role)"
              >
                <i class="bi bi-trash"></i>
              </button>

            </td>

          </tr>


          <tr
            *ngIf="
              paginatedRoles.length === 0
            "
          >

            <td
              colspan="6"
              class="empty-cell"
            >
              No roles found.
            </td>

          </tr>

        </tbody>

      </table>

    </div>


    <div class="pagination-row">

      <span>
        Page {{ pageNo }}
        of {{ totalPages }}
      </span>


      <div>

        <button
          class="pagination-btn"
          [disabled]="pageNo === 1"
          (click)="previousPage()"
        >
          Previous
        </button>

        <button
          class="pagination-btn"
          [disabled]="
            pageNo === totalPages
          "
          (click)="nextPage()"
        >
          Next
        </button>

      </div>

    </div>

  </div>

</div>